/**
 * OnboardingGateController — gate post-login + bannière de complétion sur
 * /tableau-de-bord-prospect.html (EPIC-068 / 68.2, §15.A).
 *
 * Au chargement du dashboard prospect :
 *   - GET /me/onboarding-status.
 *   - `isComplete = true` → rien (ni redirect ni bannière).
 *   - `isComplete = false` :
 *       · 1ʳᵉ fois dans la session → redirection vers /bienvenue.html
 *         (flag sessionStorage, une seule redirection par session).
 *       · ensuite → bannière de complétion non bloquante (masquable ;
 *         re-surface à la prochaine session car portée sessionStorage).
 *
 * 403 (compte non prospect) / erreur réseau → aucun gate, la page reste
 * utilisable (graceful degradation).
 *
 * Aucune construction HTML inline : la bannière vient du
 * `<template id="tpl-onboarding-banner">`.
 */

import BaseController from "./base_controller.js";
import { api } from "/js/services/api.js";

const REDIRECT_FLAG = "notamicro_onboarding_gate_redirected";
const BANNER_DISMISS_FLAG = "notamicro_onboarding_banner_dismissed";

export default class OnboardingGateController extends BaseController {
  async connect() {
    let status;
    try {
      const res = await api.getOnboardingStatus();
      status = res && res.data ? res.data : res;
    } catch (_e) {
      // 401 → /connexion.html géré par api.js ; 403 (non prospect) / réseau →
      // pas de gate, le dashboard reste lisible.
      return;
    }

    if (!status || status.isComplete === true) return;

    if (!this._sessionFlag(REDIRECT_FLAG)) {
      this._setSessionFlag(REDIRECT_FLAG);
      window.location.assign("/bienvenue.html");
      return;
    }

    this._renderBanner();
  }

  // ---------------------------------------------------------------------------
  // Bannière de complétion
  // ---------------------------------------------------------------------------

  _renderBanner() {
    if (this._sessionFlag(BANNER_DISMISS_FLAG)) return;
    const fragment = this.cloneTemplate("tpl-onboarding-banner");
    if (!fragment) return;
    this.element.replaceChildren(fragment);
    this.element.hidden = false;
  }

  dismiss() {
    this._setSessionFlag(BANNER_DISMISS_FLAG);
    this.element.replaceChildren();
    this.element.hidden = true;
  }

  // ---------------------------------------------------------------------------
  // Helpers sessionStorage (tolérants au mode privé)
  // ---------------------------------------------------------------------------

  _sessionFlag(key) {
    try {
      return sessionStorage.getItem(key) === "1";
    } catch (_e) {
      return false;
    }
  }

  _setSessionFlag(key) {
    try {
      sessionStorage.setItem(key, "1");
    } catch (_e) {
      // sessionStorage indisponible — le flag n'est pas persisté.
    }
  }
}
